import { render, staticRenderFns } from "./UsabilityDays.vue?vue&type=template&id=118b0848&"
import script from "./UsabilityDays.vue?vue&type=script&lang=js&"
export * from "./UsabilityDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports